import AuditAndCompliance from "../../../api/AuditAndCompliance"
import { useResponseHandle } from "../../hooks"

const API = new AuditAndCompliance()

export const fetchComplianceData = async (params: any) => {
  const { token, dispatch, navigate, office } = params
  const { loading } = params

  loading(true)
  const response = await API.getComplianceData(token, office?.practice_sk)

  const result: any = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
